import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function BudgetrequestextraReducer(state = initialState.budgetrequestextra, action: any) {
  switch (action.type) {
    case types.SAVE_BUDGETREQUESTEXTRA_SUCCESS:
      return action.budgetrequestextra;
    default:
      return state;
  }
}
